import slidesLVSH from './slides_LVSH';
import { featuresLVSH } from './features_LVSH';
import { ProjectType } from '../../Constants';
import { textLVSH } from './text_LVSH';

export const LVSHdata = {
    fr: {
        id: 6,
        name: 'LeVIVO Sherbrooke',
        content: textLVSH.fr,
        yearBuilt: 2021,
        address: "3395 Rue Laure-Conan, Sherbrooke, QC J1L 0J8",
        city: "Sherbrooke",
        brand: "levivo",
        projectPage: "sherbrooke",
        website: "https://levivo.ca/en/rentals-condos/levivo-sherbrooke/",
        category: ProjectType.Residential,
        images: slidesLVSH,
        features: featuresLVSH.fr
    },
    en: {
        id: 6,
        name: 'LeVIVO Sherbrooke',
        content: textLVSH.en,
        yearBuilt: 2021,
        address: "3395 Rue Laure-Conan, Sherbrooke, QC J1L 0J8",
        city: "Sherbrooke",
        brand: "levivo",
        projectPage: "sherbrooke",
        website: "https://levivo.ca/en/rentals-condos/levivo-sherbrooke/",
        category: ProjectType.Residential,
        images: slidesLVSH,
        features: featuresLVSH.en
    }
}